



























import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';

@Component
export default class Corners extends Vue {
  @Prop({ type: String, required: false }) private text!: string;
  @Prop({ type: String, required: false }) private info!: any;
  @Prop({ type: String, required: false }) private bgColor!: any;
  @Prop({ type: String, required: false }) private color!: any;
  @Prop({ type: String, required: false }) private icon!: string;
  @Prop({ type: String, required: false }) private font!: string;
  @Prop({ type: String, required: false }) private iconColor!: string;
  @Prop({ type: String, required: false }) private textColor!: string;
  private created() {
    // console.log(typeof this.info);
  }
}
